import React from 'react';
import ReactDOM from 'react-dom/client';
import AppProvider from './app/provider';
import AppRouter from './app/router';
import './styles/ivori-tokens.css';
import './index.css';
import reportWebVitals from './utils/reportWebVitals';
import { sendToAnalytics } from './utils/webVitalsSender';
import { avatarTrialProvider } from './features/interview/avatar/avatarTrial';

// An avatar trial link (?avatar=...) is remembered before anything redirects:
// a signed-out visitor is sent to /login and then /chat, and the address is lost.
avatarTrialProvider(window.location.search);

// Error handling for unhandled promises
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  
  // Prevent default browser behavior
  event.preventDefault();
  
  // Log to error tracking service in production
  if (process.env.NODE_ENV === 'production') {
    // Example: logErrorToService(event.reason, 'unhandledrejection');
  }
});

// Global error handler
window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
  
  // Log to error tracking service in production
  if (process.env.NODE_ENV === 'production') {
    // Example: logErrorToService(event.error, 'javascript-error');
  }
});


// Performance observer setup (silent in development)
if ('PerformanceObserver' in window) {
  try {
    const longTaskObserver = new PerformanceObserver((list) => {
      // Intentionally silent to keep browser console clean
    });
    longTaskObserver.observe({ entryTypes: ['longtask'] });
  } catch (error) {
    // Silently fail performance observer setup
  }
}

// Create root and render app
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render with enhanced error boundary
root.render(
  <React.StrictMode>
    <AppProvider>
      <AppRouter />
    </AppProvider>
  </React.StrictMode>
);

// Start performance monitoring
reportWebVitals(sendToAnalytics);
